import FindIdForm from "./FindIdForm";
import FindIdResult from "./FindIdResult";

export { FindIdForm, FindIdResult };

export default { FindIdForm, FindIdResult };
